export const NOTIFICATION_SUCCESS = 'NOTIFICATION/SUCCESS';
export const NOTIFICATION_ERROR = 'NOTIFICATION/ERROR';
